import * as React from 'react';
import { Select as MuiSelect, InputLabel } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { uuid } from '../../../utils/functions';

import './Select.scss';

export const Select = props => {
  const { id, onChange, value, label, disabled, color = 'primary', children } = props;
  return (
    <FormControl variant="filled" className="select-form-control">
      <InputLabel id={`${label}-select-label`}>{label}</InputLabel>
      <MuiSelect
        id={id || uuid()}
        labelId={`${label}-select-label`}
        className="threepp-select"
        onChange={onChange}
        value={value}
        disabled={disabled}
        color={color}
        IconComponent={ExpandMoreIcon}
      >
        {children}
      </MuiSelect>
    </FormControl>
  );
};
